import PublicArticleFolderDetails from './components/articleFolder/articleFolderPublicDetails/publicArticleFolderDetails';
import MachineReportDetails from './components/machines/machine_reports/readMachineReports/machineReportDetails';
import ArticleFolderDetails from './components/articleFolder/oneArticleFolderDetails/articleFolderDetails';
import PublicMachineDetails from './components/machines/machinePublicDetails/publicMachineDetails';
import EquipmentDetails from './components/equipment/oneEquipmentDetails/equipmentDetails';
import ContractDetails from './components/contracts/oneContractDetails/contractDetails';
import MachineNoteDetails from './components/machines/machine_notes/machineNoteDetails';
import CompanyDetails from './components/companies/oneCompanyDetails/companyDetails';
import MachineDetails from './components/machines/oneMachineDetails/machineDetails';
import InvoiceDetails from './components/invoices/oneInvoiceDetails/invoiceDetails';
import RegionDetails from './components/regions/oneRegionDetails/regionDetails';
import MetierDetails from './components/metier/oneMetierDetails/metierDetails';
import MarqueDetails from './components/marque/oneMarqueDetails/marqueDetails';
import RisqueDetails from './components/risque/oneRisqueDetails/risqueDetails';
import SiteDetails from './components/sites/oneSiteDetails/siteDetails';
import UserDetails from './components/users/oneUserDetails/userDetails';
import PoleDetails from './components/poles/onePoleDetails/poleDetails';
import RoleDetails from './components/roles/oneRole/roleDetails';
import { FinancialDashboard } from './pages/financialDashboard';
import UserResetPassword from './pages/userResetPassword';
import { VersionLogs } from './components/versionLogs';
import { DashboardApp } from './pages/DashboardApp';
import ChangePassword from './pages/changePassword';
import ArticleFolders from './pages/articleFolder';
import { keepListRoute } from './components/listNavigation/ListKeepAlive';
import { Navigate } from 'react-router-dom';
import Equipments from './pages/equipments';
import Contracts from './pages/contracts';
import Companies from './pages/companies';
import Invoices from './pages/invoices';
import Machines from './pages/machines';
import NotFound from './pages/Page404';
import Reports from './pages/reports';
import Regions from './pages/regions';
import { Login } from './pages/login';
import Marque from './pages/marque';
import Risque from './pages/risque';
import Metier from './pages/metier';
import Roles from './pages/roles';
import Users from './pages/users';
import Sites from './pages/sites';
import Poles from './pages/poles';

// ✅ Dashboard Routes (Authenticated Users)
export const dashboardRoutes = [

    { path: 'app', element: <DashboardApp /> },
    { path: 'financial_dashboard', element: <FinancialDashboard /> },
    keepListRoute('machines', <Machines />, [
        { path: 'machine_details/:id', element: <MachineDetails /> },
        { path: 'machine_details/:id/remarque_details', element: <MachineNoteDetails /> },
    ]),
    keepListRoute('machines_archivees', <Machines />, [
        { path: 'machine_details/:id', element: <MachineDetails /> },
        { path: 'machine_details/:id/remarque_details', element: <MachineNoteDetails /> },
    ]),
    keepListRoute('contract', <Contracts />, [
        { path: 'contract_details/:id', element: <ContractDetails /> },
    ]),
    keepListRoute('factures', <Invoices />, [
        { path: 'facture_details/:id', element: <InvoiceDetails /> },
    ]),
    keepListRoute('utilisateurs', <Users />, [
        { path: 'utilisateur_details/:id', element: <UserDetails /> },
    ]),
    keepListRoute('entreprises', <Companies />, [
        { path: 'entreprise_details/:id', element: <CompanyDetails /> },
    ]),
    keepListRoute('sites', <Sites />, [
        { path: 'site_details/:id', element: <SiteDetails /> },
    ]),
    keepListRoute('regions', <Regions />, [
        { path: 'region_details/:id', element: <RegionDetails /> },
    ]),
    keepListRoute('poles', <Poles />, [
        { path: 'pole_details/:id', element: <PoleDetails /> },
    ]),
    keepListRoute('metiers', <Metier />, [
        { path: 'metier_details/:id', element: <MetierDetails /> },
    ]),
    keepListRoute('marques', <Marque />, [
        { path: 'marque_details/:id', element: <MarqueDetails /> },
    ]),
    keepListRoute('roles', <Roles />, [
        { path: 'rôle_details/:id', element: <RoleDetails /> },
    ]),
    keepListRoute('controles', <Reports />, [
        { path: 'controle_details/:id', element: <MachineReportDetails /> },
    ]),
    { path: 'changePassword', element: <ChangePassword /> },
    { path: 'versionLogs', element: <VersionLogs /> },
    keepListRoute('risques', <Risque />, [
        { path: 'risque_details/:id', element: <RisqueDetails /> },
    ]),
    keepListRoute('equipements', <Equipments />, [
        { path: 'equipement_details/:id', element: <EquipmentDetails /> },
    ]),
    keepListRoute('dossiers_articles', <ArticleFolders />, [
        { path: 'dossiers_articles_details/:id', element: <ArticleFolderDetails /> },
    ]),
];

// ✅ Public Routes
export const publicRoutes = [
    { path: '/', element: <Navigate to="/dashboard/app" /> },
    { path: 'login', element: <Login /> },
    { path: 'resetPassword/:accessCodeId', element: <UserResetPassword /> },
    { path: 'public/machine/:token', element: <PublicMachineDetails /> },
    { path: 'public/dossiers_articles/dossiers_articles_details/:token', element: <PublicArticleFolderDetails /> },
    { path: '404', element: <NotFound /> },
    { path: '*', element: <NotFound /> },
];